module.exports = __webpack_public_path__ + "static/media/fanhub-rev.ec4374bf.svg";